module.exports = __webpack_public_path__ + "img/pic03.d374d0d1.png";